import React from "react"
import { cn } from "../utils"

export type CommandKbdProps = React.ComponentPropsWithoutRef<"kbd">

/**
 * A single key rendered in a small gray box. The shared building block for
 * keyboard affordances — used on its own (e.g. an `↵` in `Command.Hint`) or
 * grouped by `Command.Shortcut` for a chord.
 */
export function CommandKbd({ className, children, ...props }: CommandKbdProps) {
  return (
    <kbd
      className={cn(
        "flex size-4 items-center justify-center rounded-[4px] bg-gray-900/6 text-[0.6875rem] font-semibold leading-4 text-gray-900 uppercase",
        className
      )}
      {...props}
    >
      <span>{children}</span>
    </kbd>
  )
}

CommandKbd.displayName = "Command.Kbd"
